import { render, staticRenderFns } from "./NameRecord.vue?vue&type=template&id=b3a57cda&scoped=true&"
import script from "./NameRecord.vue?vue&type=script&lang=js&"
export * from "./NameRecord.vue?vue&type=script&lang=js&"
import style0 from "./NameRecord.vue?vue&type=style&index=0&id=b3a57cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a57cda",
  null
  
)

export default component.exports